import { render, staticRenderFns } from "./erm_log_help.vue?vue&type=template&id=9b8c730e&scoped=true&"
import script from "./erm_log_help.vue?vue&type=script&lang=js&"
export * from "./erm_log_help.vue?vue&type=script&lang=js&"
import style0 from "./erm_log_help.vue?vue&type=style&index=0&id=9b8c730e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b8c730e",
  null
  
)

export default component.exports